export const isElementInViewportTop = (el: Element): boolean => el && el.getBoundingClientRect().top >= 0;
